import React from 'react';

import {Link} from 'react-router-dom';
import {Stack, Typography} from '@mui/material';

import Env from 'env';

import theme_ from 'theme/Theme';
import PageImage from 'tsui/PageImage';

export default function PageLogo() {
    return (
        <Link to='/' style={{
            textDecoration: 'none',
        }}>
            <Stack direction='row'>
                <PageImage
                    src='/images/company-logo-dark.svg'
                    alt='Evotek'
                    width={theme_.pageLogoWidth}
                    sx={{m: Env.isMobile ? 1 : 2}}
                />
                <Typography
                    sx={{
                        color: 'red',
                        fontSize: '2rem',
                        fontStyle: 'italic',
                        mt: 2,
                    }}
                >
                    ADMIN
                </Typography>
            </Stack>
        </Link>
    );
}
